import { render, staticRenderFns } from "./ShopMsg.vue?vue&type=template&id=c92d1a3a&scoped=true&"
import script from "./ShopMsg.vue?vue&type=script&lang=js&"
export * from "./ShopMsg.vue?vue&type=script&lang=js&"
import style0 from "./ShopMsg.vue?vue&type=style&index=0&id=c92d1a3a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92d1a3a",
  null
  
)

export default component.exports